// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_AdminCancelResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_AdminCancelResponse — result of POST /subscriptions/admin/cancel.
 *
 * SUCCESS ONLY. Every non-cancelled outcome of SubscriptionCancellationService
 * (refused, deferred, gateway_failed, local_write_failed) leaves the controller
 * through sendError(), so this contract never has to carry a failure flag —
 * carrying one is exactly how a refusal ends up wearing a success envelope
 * (skill billing-staff-console §4).
 *
 * previous_status is the status the row held BEFORE the cut, so the console can
 * say what it actually ended. `remote` names what happened at the provider:
 * 'cancelled_at_provider', or 'skipped_no_provider_subscription' when the row
 * never had anything created at the gateway (a checkout that was never
 * completed) — a real distinction, since only the first one stopped a charge.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_AdminCancelResponseDados {
subscription_id: number
status: string
previous_status: string
remote: string
}

export type Subscriptions_AdminCancelResponse = ApiResponse<Subscriptions_AdminCancelResponseDados>;

registerResponseContract('Subscriptions_AdminCancelResponse', {
  subscription_id: { type: 'number',  required: true },
  status:          { type: 'string',  required: true },
  previous_status: { type: 'string',  required: false },
  remote:          { type: 'string',  required: false },
})
